import { Link } from "react-router-dom";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import { blogArticles } from "../../data/blogArticles";

export default function Blog() {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-16">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between mb-16">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-blue-50 rounded-full mb-6 border border-blue-100">
              <div className="w-1.5 h-1.5 rounded-full bg-[#0186ef]" />
              <span className="text-xs font-semibold text-[#0186ef] uppercase tracking-wider">
                Insights
              </span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 leading-tight">
              Articles & News
            </h2>
            <p className="mt-4 text-lg text-gray-500 max-w-lg">
              Honest perspectives on software, product development, and building
              technology for emerging markets.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {blogArticles.map((article) => (
            <Link
              key={article.id}
              to={`/blog/${article.slug}`}
              className="group flex flex-col rounded-2xl overflow-hidden border border-gray-100 hover:shadow-xl transition-all duration-500 hover:-translate-y-1"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute top-4 left-4">
                  <span className="inline-flex px-3 py-1 bg-white/90 backdrop-blur-sm rounded-full text-xs font-semibold text-gray-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex-1 p-6">
                <div className="flex items-center gap-3 mb-2">
                  <time className="text-xs text-gray-400 font-medium">
                    {article.date}
                  </time>
                  <span className="text-xs text-gray-300">·</span>
                  <span className="text-xs text-gray-400">{article.readTime}</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 leading-snug group-hover:text-[#0186ef] transition-colors">
                  {article.title}
                </h3>
                <p className="mt-3 text-sm text-gray-500 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
              <div className="px-6 pb-6">
                <span className="inline-flex items-center text-sm font-semibold text-[#0186ef] group-hover:underline">
                  Read article
                  <ArrowLongRightIcon className="ml-1 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
